import { ConversationBuilderService } from "@/services/conversation-builder";
import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import { ConversationBuilderLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";
@Component({
	components: {}
})
export default class ConversationVoiceGenerationTimer extends Vue {
	@Prop({ default: 0 }) conversationId!: number;
	@Prop({ default: true }) isTestConversation!: boolean;

	public conversationBuilderService = ConversationBuilderService;
	public voiceGenCountDown: string | null = null;
	private voiceGenTimeInternal: NodeJS.Timeout | undefined = undefined;

	created() {
		this.conversationBuilderService
			.getConversationVoiceGenerationTime(this.conversationId)
			.then((voiceGenTime) => {
				if (voiceGenTime) {
					this.checkVoiceGenTimeout(voiceGenTime);
				}
			})
			.catch((err) => {});
	}

	get timeLabel() {
		return this.isTestConversation
			? fmtMsg(ConversationBuilderLocale.ConversationVoiceGenTestTimeCountDownLabel)
			: fmtMsg(ConversationBuilderLocale.ConversationVoiceGenTimeCountDownLabel);
	}

	checkVoiceGenTimeout(voiceGenTime) {
		const countDownDate = moment.utc(voiceGenTime).add(2, "hours");
		const timeout = setInterval(() => {
			var distance = moment().utc().diff(countDownDate, "seconds");

			// Time calculations for hours, minutes and seconds
			var hours = Math.trunc(distance / (60 * 60));
			var minutes = Math.trunc((distance - hours * 60 * 60) / 60);
			var seconds = distance % 60;

			this.voiceGenCountDown = Math.abs(hours) + "h " + Math.abs(minutes) + "m " + Math.abs(seconds) + "s ";

			// If the count down is finished, write some text
			if (distance > 0) {
				clearInterval(this.voiceGenTimeInternal as NodeJS.Timeout);
				this.voiceGenCountDown = 0 + "h " + 0 + "m " + 0 + "s ";
			}
		}, 1000);

		this.voiceGenTimeInternal = timeout;
	}

	destroyed() {
		clearInterval(this.voiceGenTimeInternal as NodeJS.Timeout);
	}
}
